import {
    Authenticator,
    Theme,
    ThemeProvider,
    Flex,
} from "@aws-amplify/ui-react"
// eslint-disable-next-line import/no-unresolved
import "@aws-amplify/ui-react/styles.css"
import { Theme as MuiTheme, useMediaQuery } from "@mui/material"
import { Amplify } from "aws-amplify"
import { ReactElement } from "react"

import { authComponents } from "./authComponents"
import { authFormFields } from "./authFormFields"
import awsExports from "./aws-exports"
import LoginScreenEvcp from "../assets/login-screen-evcp.png"
import LoginScreenHp from "../assets/login-screen-hp.png"
import ConnectDirectLogo from "../components/logos/logos"
import { ENA_BLUE_1OO, ENA_ORANGE_100 } from "../themes/colours"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

// Configure amplify authenticator with app cognito user-pool. Password
// policy must be kept aligned with cognito.s
Amplify.configure({
    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 10,
        passwordPolicyCharacters: [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE",
        ],
    },
    Auth: {
        region: awsExports.AWS_REGION,
        userPoolId: awsExports.USER_POOL_ID,
        userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID,
        cookieStorage: {
            domain: CONFIG.WEB_APPLICATION_URL,
            secure: CONFIG.SECURE,
            sameSite: "strict",
        },
    },
})

/**
 * Provides AWS cognito sign-in functionality. A user must authentication
 * successfully to access child components. If a user is not authenticated
 * and tries to access children, they will be redirected to a sign-in page.
 * This page allows user to create an account, sign into an account and
 * reset a forgotten password. The sign-up form is defined in the following
 * typescript files: `authComponents.tsx`, `authFormFields.ts`

 */

const AuthProvider = (): ReactElement => {
    const theme: Theme = {
        name: "Auth Example Theme",
        tokens: {
            components: {
                button: {
                    primary: {
                        backgroundColor: ENA_BLUE_1OO,
                    },
                    link: {
                        color: ENA_BLUE_1OO,
                    },
                },
                tabs: {
                    item: {
                        color: ENA_BLUE_1OO,
                        _active: {
                            borderColor: ENA_ORANGE_100,
                            color: ENA_ORANGE_100,
                        },
                    },
                },
            },
        },
    }
    const isMob = useMediaQuery((th: MuiTheme) => th.breakpoints.down("md"))

    return (
        <ThemeProvider theme={theme}>
            <Flex
                style={{
                    backgroundImage: `url("${
                        Math.round(Math.random()) === 1
                            ? LoginScreenEvcp
                            : LoginScreenHp
                    }")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
                direction={isMob ? "column" : "row"}
                justifyContent="space-between"
                alignContent="flex-start"
                width="100vw"
                height="100vh"
                padding={16}
            >
                {!isMob && (
                    <Flex alignItems="flex-start">
                        <ConnectDirectLogo
                            fontSize="350px"
                            viewBox="440 350 1070 400"
                            modeOverride="dark"
                        />
                    </Flex>
                )}
                <Authenticator
                    className="authContainer"
                    components={authComponents}
                    formFields={authFormFields}
                />
            </Flex>
        </ThemeProvider>
    )
}
export default AuthProvider
